<template>
    <div class="document-input">
        <button
            v-show="!(matchMedia?.max.Tiny && promptTerm)"
            data-testid="advanced-search-document-upload-trigger"
            type="button"
            title="Upload document"
            class="document-input_button"
            @click="inputFileRef?.click()"
        >
            <VJoyIcon size="small" name="paperclip" color="neutral" />
        </button>
        <input
            ref="inputFileRef"
            accept="application/pdf"
            type="file"
            style="display: none"
            data-testid="advanced-search-document-upload-input"
            @change="handleFileChange"
        />
    </div>
</template>

<script setup lang="ts">
    import {watch, useTemplateRef} from 'vue';
    import {useMediaQuery} from '@malt/utils';
    import {VJoyIcon} from '@maltjoy/core-vue';

    export type DocumentButtonInputProps = {promptTerm?: string};

    defineProps<DocumentButtonInputProps>();

    // v-model
    const documentUpload = defineModel<File>();

    const {matchMedia} = useMediaQuery();
    const inputFileRef = useTemplateRef('inputFileRef');

    function handleFileChange(event: Event) {
        handleFileTreatment((event.target as HTMLInputElement).files?.[0]);
    }
    function handleFileTreatment(file?: File) {
        if (file) documentUpload.value = file;
    }
    watch(documentUpload, (val) => {
        if (!val && inputFileRef.value) {
            inputFileRef.value.value = '';
        }
    });
</script>

<style lang="scss" scoped>
    .document-input {
        flex: 0 0 auto;
        display: flex;
        align-items: flex-start;

        &_button {
            display: flex;
            cursor: pointer;
            padding: 6px;
            border-radius: 100px;
            transition: background-color 0.3s ease;

            &:hover {
                background-color: var(--joy-color-neutral-20);
            }

            &:active {
                background-color: var(--joy-color-neutral-30);
            }
        }
    }
</style>
